/**
 * Product page only behaviour for Alpha Chino.
 * Loaded in addition to the shared core script (countdown, FAQ, sliders, video).
 *
 * Handles:
 *  - Product image gallery (thumbnail -> main image)
 *  - Bundle selector (one / two / three packs) - subscription only
 *  - Live price / per-serving / renewal copy + CTA label
 *  - Sticky mobile add-to-cart bar
 *  - "View supplement facts" accordion
 *
 * Selection state is reflected with the data-selected attribute, and the
 * matching visuals live in the markup via Tailwind data-[selected=true]:*
 * variants - so styling stays in Tailwind, never in custom CSS.
 */
(function () {
  "use strict";

  function initPurchase() {
    var root = document.getElementById("appwiz-yash-purchase");
    if (!root) {
      return;
    }

    var state = { bundle: "three" }; // Default: three packs selected

    var bundleBtns = Array.prototype.slice.call(
      root.querySelectorAll("[data-pp-bundle]"),
    );
    var sticky = document.getElementById("appwiz-yash-sticky");

    function setText(scope, selector, value) {
      scope.querySelectorAll(selector).forEach(function (el) {
        el.textContent = value;
      });
    }

    function render() {
      // Bundle selected states
      bundleBtns.forEach(function (b) {
        var on = b.getAttribute("data-pp-bundle") === state.bundle;
        b.setAttribute("data-selected", String(on));
        b.setAttribute("aria-pressed", String(on));
      });

      // The price box is owned by the hero section's own script and its data-sub-* figures.

      // Sticky mobile bar: price and checkout follow the selected bundle's subscription
      var selectedBtn = root.querySelector("[data-pp-bundle='" + state.bundle + "']");
      if (sticky && selectedBtn) {
        setText(sticky, "[data-pp-sticky-price]", selectedBtn.getAttribute("data-sub-price") || "");
        setText(sticky, "[data-pp-sticky-cta]", "Subscribe & Save");
        var stickyBtn = sticky.querySelector(".alpha-appwiz-recharge-direct-checkout");
        if (stickyBtn) {
          stickyBtn.setAttribute("data-variant-id", selectedBtn.getAttribute("data-sub-variant-id") || "");
          stickyBtn.setAttribute("data-selling-plan-id", selectedBtn.getAttribute("data-sub-selling-plan-id") || "");
        }
      }
    }

    bundleBtns.forEach(function (b) {
      b.addEventListener("click", function () {
        state.bundle = b.getAttribute("data-pp-bundle");
        render();
      });
    });

    render();
    initStickyVisibility(sticky);
  }

  /* --------------------------- Sticky mobile bar --------------------------- */
  // Shows the bar once the hero purchase box has scrolled out of view, and
  // hides it again as the final CTA enters view (so the two never overlap).
  // A scroll listener is used rather than IntersectionObserver so the behaviour
  // is reliable across every environment.
  function initStickyVisibility(sticky) {
    var hero = document.getElementById("appwiz-yash-purchase");
    if (!sticky || !hero) {
      return;
    }
    var finalCta = document.getElementById("appwiz-yash-final-cta");

    function update() {
      var pastHero = hero.getBoundingClientRect().bottom < 0;
      var atEnd = finalCta
        ? finalCta.getBoundingClientRect().top < window.innerHeight
        : false;
      sticky.setAttribute("data-visible", String(pastHero && !atEnd));
    }

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  /* ----------------------------- Image gallery ----------------------------- */
  function initGallery() {
    var gallery = document.getElementById("appwiz-yash-gallery");
    if (!gallery) {
      return;
    }
    var main = gallery.querySelector("[data-pp-main]");
    var thumbs = Array.prototype.slice.call(
      gallery.querySelectorAll("[data-pp-thumb]"),
    );
    if (!main || !thumbs.length) {
      return;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var src = thumb.getAttribute("data-pp-full");
        var alt = thumb.getAttribute("data-pp-alt") || main.alt;
        if (src) {
          main.src = src;
          main.alt = alt;
        }
        thumbs.forEach(function (t) {
          t.setAttribute("data-selected", String(t === thumb));
        });
      });
    });
  }

  /* ------------------------ Generic toggle accordions ----------------------- */
  // Used by "View Supplement Facts". Reuses the same aria pattern as the FAQ.
  function initToggles() {
    document
      .querySelectorAll("[data-pp-toggle]")
      .forEach(function (button) {
        button.addEventListener("click", function () {
          var panel = document.getElementById(
            button.getAttribute("aria-controls"),
          );
          if (!panel) {
            return;
          }
          var expanded = button.getAttribute("aria-expanded") === "true";
          button.setAttribute("aria-expanded", String(!expanded));
          panel.hidden = expanded;
        });
      });
  }

  function init() {
    initPurchase();
    initGallery();
    initToggles();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
